import { CheckSquareOffsetIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { editTaskSummary } from 'app/lib/workflows/format'
import type { EditTaskFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Edits the task made by the Create task above it. Lives only on a task path; the shared issues
 *  map flags it anywhere else. */
export function EditTaskNode({ data, selected }: NodeProps<EditTaskFlowNode>) {
  return (
    <NodeShell
      icon={CheckSquareOffsetIcon}
      accent="teal"
      kind="Edit task"
      label={data.label}
      description={editTaskSummary(data)}
      selected={selected}
    />
  )
}
